<script>
import ScheduleList from '../SchedulesList'
export default {
  name: 'scheduled-schedules',
  extends: ScheduleList,
  computed: {
    tabSchedule () {
      return this.$store.getters.finishedSchedule
    }
  },
  mounted () {
    if (this.$store.getters.finishedSchedule.length === 0) {
      this.$store.dispatch('getFinishedSchedule')
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?3168c32a